import React from 'react';

// Conditionally wraps `children` in another component.
const maybeWrapWith = Component => ({ children, condition, ...rest }) => {
  if (condition) {
    return <Component {...rest}>{children}</Component>;
  }

  return children;
};

export default maybeWrapWith;
